import React from 'react';
import Modal from './Modal';

/**
 * パスワード変更成功時に表示するモーダル
 */
const PasswordChangeSuccessModal = ({ 
  isOpen, 
  onClose, 
  onNavigateToLogin ,
  showCloseButton = false
}) => {
  const handleLoginRedirect = () => {
    onClose();
    if (onNavigateToLogin) {
      onNavigateToLogin();
    }
  };

  const styles = {
    container: {
      textAlign: 'center',
      padding: '20px'
    },
    icon: {
      fontSize: '48px',
      color: '#28a745',
      marginBottom: '20px'
    },
    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '16px'
    },
    message: {
      fontSize: '16px',
      color: '#666',
      lineHeight: '1.6',
      marginBottom: '30px'
    },
    buttonContainer: {
      display: 'flex',
      gap: '12px',
      justifyContent: 'center'
    },
    button: {
      padding: '12px 24px',
      borderRadius: '6px',
      fontSize: '16px',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      border: 'none'
    },
    primaryButton: {
      backgroundColor: '#09529f',
      color: '#fff'
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      showCloseButton={showCloseButton}
      closeOnBackdropClick={false}
      closeOnEscape={false}
    >
      <div style={styles.container}>
        <h2 style={styles.title}>
          パスワード変更完了
        </h2>
        
        <p style={styles.message}>
          <span>パスワードの変更が正常に完了しました。</span><br />
          <span>新しいパスワードでログインしてください。</span>
        </p>
        
        <div style={styles.buttonContainer}>
          <button 
            style={{...styles.button, ...styles.primaryButton}}
            onClick={handleLoginRedirect}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#002348';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#09529f';
            }}
          >
            ログイン画面へ
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PasswordChangeSuccessModal;